import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { IOrganizacaoEndereco } from "../../../../Interfaces/Organizacao/Organizacao";

interface IOrganizacaoInfoEndereco {
    infoEndereco: IOrganizacaoEndereco | undefined;
}

export default function InfoEndereco(props: IOrganizacaoInfoEndereco) {
    const FormMethods = useForm();

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={() => console.log("SemInfoAinda")}
                className="row justify-content-center"
            >
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_BAIRRO"
                        label="Bairro"
                        readOnly
                        defaultValue={props.infoEndereco?.DS_BAIRRO}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_LOGRADOURO"
                        label="Logradouro"
                        readOnly
                        defaultValue={props.infoEndereco?.DS_LOGRADOURO}
                    />
                </div>

                <div className="form-group col-6">
                    <UnForm.Input
                        type="number"
                        name="NR_ENDERECO"
                        label="Endereço"
                        readOnly
                        defaultValue={props.infoEndereco?.NR_ENDERECO}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_COMPLEMENTO_ENDERECO"
                        label="Complemento Endereço"
                        readOnly
                        defaultValue={
                            props.infoEndereco?.DS_COMPLEMENTO_ENDERECO
                        }
                    />
                </div>
            </UnForm>
        </FormProvider>
    );
}
